import { ERROR_HANDLER_SET, ERROR_HANDLER_RESET } from './actions';
import _ from 'lodash';

const initialState = {
	errorId: null
};

export default (state = initialState, action) => {

	switch (action.type) {

		case ERROR_HANDLER_SET:
			return {
				...state,
				errorId: _.get(action, 'error.errorId'),
				errorMessage: _.get(action, 'error.errorMessage')
			};

		case ERROR_HANDLER_RESET:
			return {
				...state,
				errorId: null
			};

		default:
			return state;
	}
};

export const resetErrorId = () => ({
	type: ERROR_HANDLER_RESET
});

export const setErrorId = (errorId) => ({
	type: ERROR_HANDLER_SET,
	error: {
		errorId: errorId
	}
});


// WEBPACK FOOTER //
// ./src/redux/modules/error.js